import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { RefreshCw, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { ROLES_PRO } from '../login/ChoixRolePro';

// Corriger le rôle d'une demande en attente avant validation
export const ChangerRoleDemande = ({ registration, onChange }) => {
  const [ouvert, setOuvert] = useState(false);
  const [role, setRole] = useState(registration.role);
  const [saving, setSaving] = useState(false);
  const id = registration.user_id;

  const enregistrer = async () => {
    setSaving(true);
    try {
      await axios.patch(`/pending-registrations/${id}/role`, { role });
      toast.success(`Rôle changé : ${ROLES_PRO.find(r => r.value === role)?.label}`);
      onChange(role);
      setOuvert(false);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erreur lors du changement de rôle');
    } finally {
      setSaving(false);
    }
  };

  if (!ouvert) {
    return (
      <button type="button" onClick={() => { setRole(registration.role); setOuvert(true); }}
        className="inline-flex items-center gap-1 text-xs font-medium text-slate-500 hover:text-[#0F172A]" data-testid={`btn-changer-role-${id}`}>
        <RefreshCw className="h-3 w-3" /> Changer le rôle
      </button>
    );
  }

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`changer-role-panel-${id}`}>
      <select value={role} onChange={(e) => setRole(e.target.value)}
        className="h-8 rounded-md border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#8DC63F]"
        data-testid={`select-role-${id}`}>
        {ROLES_PRO.map(r => <option key={r.value} value={r.value}>{r.label}</option>)}
      </select>
      <Button size="sm" onClick={enregistrer} disabled={saving || role === registration.role}
        className="h-8 bg-[#0F172A] hover:bg-[#1e293b] text-white" data-testid={`btn-save-role-${id}`}>
        {saving && <Loader2 className="h-3.5 w-3.5 mr-1 animate-spin" />}Enregistrer
      </Button>
      <button type="button" onClick={() => setOuvert(false)} className="text-xs text-slate-500 hover:underline" data-testid={`btn-cancel-role-${id}`}>
        Annuler
      </button>
    </div>
  );
};
